export const MINI_TIME = 500
export const TIME_OUT_MAX = 25000
export const DM_HOST = 'http://loan-mobile-qa-02.idumiao.com'
export const WALLET_HOST = 'http://h5-wallet-qa-02.idumiao.com'
export const FRAUDMETRIX_HOST = 'https://fptest.fraudmetrix.cn'